// The short credit where numbers are shown (DIRECTION D1, B-593): each
// source's sentence as its license words it, and the credits page a press
// away. The front page's foot, the foot of Players and the end of a player's
// card carry it; the last two only in a real league, since the practice
// league's players and their numbers are the simulator's own inventions.
//
// The sentences are the server's (`GET /api/credits`), so this names no
// source of its own. Nothing is drawn until they arrive, and nothing if they
// never do: the credits page says that read failed, and a line saying so under
// every list would be noise.

import { Link } from 'react-router-dom';
import { useCreditLines } from '../../data/credits';

export function DataCredit({ link = true }: { link?: boolean }) {
  const lines = useCreditLines();
  if (lines.length === 0) return null;
  return (
    <div className="fsp-sub fsp-data-credit">
      {lines.map((l) => l.text).join(' ')}
      {link ? (
        <>
          {' '}
          <Link className="fsp-linklike" to="/credits">
            Credits
          </Link>
        </>
      ) : null}
    </div>
  );
}
